var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircleFull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#079455"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49984 1.99984C5.18613 1.99984 2.49984 4.68613 2.49984 7.99984C2.49984 11.3135 5.18613 13.9998 8.49984 13.9998C11.8135 13.9998 14.4998 11.3135 14.4998 7.99984C14.4998 4.68613 11.8135 1.99984 8.49984 1.99984ZM1.1665 7.99984C1.1665 3.94975 4.44975 0.666504 8.49984 0.666504C12.5499 0.666504 15.8332 3.94975 15.8332 7.99984C15.8332 12.0499 12.5499 15.3332 8.49984 15.3332C4.44975 15.3332 1.1665 12.0499 1.1665 7.99984ZM11.9712 5.52843C12.2316 5.78878 12.2316 6.21089 11.9712 6.47124L7.97124 10.4712C7.71089 10.7316 7.28878 10.7316 7.02843 10.4712L5.02843 8.47124C4.76808 8.21089 4.76808 7.78878 5.02843 7.52843C5.28878 7.26808 5.71089 7.26808 5.97124 7.52843L7.49984 9.05703L11.0284 5.52843C11.2888 5.26808 11.7109 5.26808 11.9712 5.52843Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleFull);
export default __webpack_public_path__ + "static/media/check-circle-full.37c71055f651808314008eb84198f04a.svg";
export { ForwardRef as ReactComponent };